import { Service } from "../shared/Service";

export class EmpreendedorService extends Service{

    constructor(){
        super('empreendedor');
    }

}